module.exports = __webpack_public_path__ + "img/1561041308.ee7ad4ba.jpg";